import React, { useContext, useEffect, useState } from 'react'
import PageWrapper from '../../layout/PageWrapper/PageWrapper'
import Page from '../../layout/Page/Page'
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from '../bootstrap/Card'
import Input from '../bootstrap/forms/Input'
import Button, { ButtonGroup } from '../bootstrap/Button'
import { useFormik } from 'formik'
import Icon from '../icon/Icon'
import { showLoader, TableLoader } from '../../services/loader.services'
import NoDataMsg from '../../common/components/NoDataMsg'
import useSortableData from '../../hooks/useSortableData'
import PaginationButtons, { dataPagination } from '../PaginationButtons'
import { toasts } from '../../services/toaste.service'
import { addProduct, deleteProduct, getProduct, getSubModuleType, updateProduct, updateMobileVisibility } from '../../services/productService'
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from '../bootstrap/OffCanvas'
import Checks from '../bootstrap/forms/Checks'
import Spinner from '../bootstrap/Spinner'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../bootstrap/Modal'
import FormGroup from '../bootstrap/forms/FormGroup'
import SearchableSelect from '../../common/components/SearchableSelect'
import InputGroup from '../bootstrap/forms/InputGroup'
import { getLicenseKey } from '../../services/application.settings'
import AuthContext from '../../contexts/authContext'
import AlertService from '../../services/alert.service'

const MasterProduct = () => {

    const { userAccountId } = useContext(AuthContext);

    useEffect(() => {
        getProductList();
    }, []);

    const columnVisibileForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
        },
        validate: (values) => { },
        onSubmit: () => { },
    });

    const [productData, setProductData] = useState<any>([])
    const [noDataMsg, setNoDataMsg] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [dataStatus, setDataStatus] = useState(false)

    const { items, requestSort, getClassNamesFor } = useSortableData(productData);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    // Filter
    const filteredData = onCurrentPageData.filter(
        (i: any) =>
            (i.lotNo && i.lotNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.countNo && i.countNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.blend && i.blend.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.noOfCone && i.noOfCone.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.coneWeight && i.coneWeight.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.tareWeight && i.tareWeight.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.netWeight && i.netWeight.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.targetWeight && i.targetWeight.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.upperWeightTolerance && i.upperWeightTolerance.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.lowerWeightTolerance && i.lowerWeightTolerance.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase()))
    );

    function getProductList() {
        getProduct(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.product;
                    if (data != undefined) {
                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                        }
                        setProductData(data)
                        setDataStatus(true)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setProductData([])
                    setNoDataMsg(response.data.message)
                    setDataStatus(true)
                } else {
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    // Add Product Logic
    const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState<any>(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState<any>(null);
    const [loadingProductId, setLoadingProductId] = useState<any>(null);

    function onDelete(productId: any) {
        setSelectedProductId(productId);
        setIsDeleteModalOpen(true);
    }

    function confirmDelete() {
        if (!selectedProductId) return;
        showLoader(true);
        const postData = {
            licenseKey: getLicenseKey.toString(),
            productId: selectedProductId,
        };
        deleteProduct(postData,
            (response) => {
                showLoader(false);
                if (response.data.success) {
                    setAlertStatus({ message: response.data.message, type: "success" });
                    setIsAlertOpen(true);
                    setIsDeleteModalOpen(false);
                    getProductList();
                } else {
                    setAlertStatus({ message: response.data.message || "Failed to delete", type: "error" });
                    setIsAlertOpen(true);
                }
            },
            (error) => {
                showLoader(false);
                setAlertStatus({ message: error, type: "error" });
                setIsAlertOpen(true);
            }
        );
    }

    const [lotList, setLotList] = useState([]);
    const [countList, setCountList] = useState([]);
    const [blendList, setBlendList] = useState([]);
    const [tareList, setTareList] = useState([]);
    const [netList, setNetList] = useState([]);

    const [isLotInput, setIsLotInput] = useState(false);
    const [isCountInput, setIsCountInput] = useState(false);
    const [isBlendInput, setIsBlendInput] = useState(false);
    const [isTareInput, setIsTareInput] = useState(false);
    const [isNetInput, setIsNetInput] = useState(false);

    const [lotSelected, setLotSelected] = useState<any>(null);
    const [countSelected, setCountSelected] = useState<any>(null);
    const [blendSelected, setBlendSelected] = useState<any>(null);
    const [tareSelected, setTareSelected] = useState<any>(null);
    const [netSelected, setNetSelected] = useState<any>(null);

    const formik = useFormik({
        initialValues: {
            lotNo: '',
            countNo: '',
            blend: '',
            noOfCone: '',
            coneWeight: '',
            tareWeight: '',
            netWeight: '',
            targetWeight: '',
            upperWeightTolerance: '',
            lowerWeightTolerance: '',
        },
        validate: (values) => {
            const errors: any = {};
            if (!isLotInput && !lotSelected) errors.lotNo = 'Required';
            if (isLotInput && !values.lotNo) errors.lotNo = 'Required';
            if (!isCountInput && !countSelected) errors.countNo = 'Required';
            if (isCountInput && !values.countNo) errors.countNo = 'Required';
            if (!isBlendInput && !blendSelected) errors.blend = 'Required';
            if (isBlendInput && !values.blend) errors.blend = 'Required';
            if (!isTareInput && !tareSelected) errors.tareWeight = 'Required';
            if (isTareInput && !values.tareWeight) errors.tareWeight = 'Required';
            if (!isNetInput && !netSelected) errors.netWeight = 'Required';
            if (isNetInput && !values.netWeight) errors.netWeight = 'Required';
            return errors;
        },
        onSubmit: (values) => {
            if (isEditMode) {
                handleUpdateProduct(values);
            } else {
                handleAddProduct(values);
            }
        },
    });

    useEffect(() => {
        const tare = isTareInput ? Number(formik.values.tareWeight) : Number(tareSelected?.label || 0);
        const net = isNetInput ? Number(formik.values.netWeight) : Number(netSelected?.label || 0);
        formik.setFieldValue('targetWeight', (tare + net).toFixed(3));
    }, [formik.values.tareWeight, formik.values.netWeight, tareSelected, netSelected, isTareInput, isNetInput]);

    function fetchDropdowns() {
        const handleRes = (res: any, setList: any, setInput: any) => {
            if (res?.data?.success && res?.data?.data?.subModuleType && res.data.data.subModuleType.length > 0) {
                setList(res.data.data.subModuleType);
                setInput(false);
            } else {
                setList([]);
                setInput(true);
            }
        };
        getSubModuleType(1, (res) => handleRes(res, setLotList, setIsLotInput), (err) => toasts(err, "Error"));
        getSubModuleType(2, (res) => handleRes(res, setCountList, setIsCountInput), (err) => toasts(err, "Error"));
        getSubModuleType(3, (res) => handleRes(res, setBlendList, setIsBlendInput), (err) => toasts(err, "Error"));
        getSubModuleType(4, (res) => handleRes(res, setTareList, setIsTareInput), (err) => toasts(err, "Error"));
        getSubModuleType(5, (res) => handleRes(res, setNetList, setIsNetInput), (err) => toasts(err, "Error"));
    }

    function openAddModal() {
        setIsEditMode(false);
        setSelectedProduct(null);
        formik.resetForm();
        setLotSelected(null);
        setCountSelected(null);
        setBlendSelected(null);
        setTareSelected(null);
        setNetSelected(null);
        setIsLotInput(false);
        setIsCountInput(false);
        setIsBlendInput(false);
        setIsTareInput(false);
        setIsNetInput(false);
        fetchDropdowns();
        setIsOffCanvasOpen(true);
    }

    function openEditModal(item: any) {
        setIsEditMode(true);
        setSelectedProduct(item);
        formik.setValues({
            lotNo: item.lotNo,
            countNo: item.countNo,
            blend: item.blend,
            noOfCone: item.noOfCone?.toString() || '',
            coneWeight: item.coneWeight || '',
            tareWeight: item.tareWeight,
            netWeight: item.netWeight,
            targetWeight: item.targetWeight,
            upperWeightTolerance: item.upperWeightTolerance,
            lowerWeightTolerance: item.lowerWeightTolerance,
        });
        setLotSelected({ value: item.lotId, label: item.lotNo });
        setCountSelected({ value: item.countId, label: item.countNo });
        setBlendSelected({ value: item.blendId, label: item.blend });
        setTareSelected({ value: item.tareWeightId, label: item.tareWeight });
        setNetSelected({ value: item.netWeightId, label: item.netWeight });
        setIsLotInput(false);
        setIsCountInput(false);
        setIsBlendInput(false);
        setIsTareInput(false);
        setIsNetInput(false);
        fetchDropdowns();
        setIsOffCanvasOpen(true);
    }

    function handleAddProduct(values: any) {
        showLoader(true);
        const postData = {
            licenseKey: getLicenseKey.toString(),
            lotNo: isLotInput ? values.lotNo : lotSelected?.label,
            countNo: isCountInput ? values.countNo : countSelected?.label,
            blend: isBlendInput ? values.blend : blendSelected?.label,
            noOfCone: Number(values.noOfCone),
            coneWeight: values.coneWeight,
            tareWeight: isTareInput ? values.tareWeight : tareSelected?.label,
            netWeight: isNetInput ? values.netWeight : netSelected?.label,
            upperWeightTolerance: values.upperWeightTolerance,
            lowerWeightTolerance: values.lowerWeightTolerance,
            userAccountId: userAccountId.toString()
        };

        addProduct(postData,
            (response) => {
                showLoader(false);
                if (response.data.success) {
                    setAlertStatus({ message: response.data.message, type: "success" });
                    setIsAlertOpen(true);
                    setIsOffCanvasOpen(false);
                    getProductList();
                } else {
                    setAlertStatus({ message: response.data.message, type: "error" });
                    setIsAlertOpen(true);
                }
            },
            (error) => {
                showLoader(false);
                setAlertStatus({ message: error, type: "error" });
                setIsAlertOpen(true);
            }
        );
    }

    function handleUpdateProduct(values: any) {
        showLoader(true);
        const postData = {
            licenseKey: getLicenseKey.toString(),
            productId: selectedProduct.productId,
            lotNo: isLotInput ? values.lotNo : lotSelected?.label,
            countNo: isCountInput ? values.countNo : countSelected?.label,
            blend: isBlendInput ? values.blend : blendSelected?.label,
            noOfCone: Number(values.noOfCone),
            coneWeight: values.coneWeight,
            tareWeight: isTareInput ? values.tareWeight : tareSelected?.label,
            netWeight: isNetInput ? values.netWeight : netSelected?.label,
            upperWeightTolerance: values.upperWeightTolerance || 0,
            lowerWeightTolerance: values.lowerWeightTolerance || 0,
            userAccountId: userAccountId.toString()
        };

        updateProduct(postData,
            (response) => {
                showLoader(false);
                if (response.data.success) {
                    setAlertStatus({ message: response.data.message, type: "success" });
                    setIsAlertOpen(true);
                    setIsOffCanvasOpen(false);
                    getProductList();
                } else {
                    setAlertStatus({ message: response.data.message, type: "error" });
                    setIsAlertOpen(true);
                }
            },
            (error) => {
                showLoader(false);
                setAlertStatus({ message: error, type: "error" });
                setIsAlertOpen(true);
            }
        );
    }

    const handleMobileVisibilityChange = (item: any, isChecked: boolean) => {
        setLoadingProductId(item.productId);
        const isVisible = isChecked ? 1 : 0;
        const postData = {
            licenseKey: getLicenseKey.toString(),
            productId: item.productId,
            isVisible: isVisible,
            userAccountId: userAccountId.toString()
        };

        updateMobileVisibility(postData,
            (response) => {
                setLoadingProductId(null);
                if (response.data.success) {
                    // toasts(response.data.message, "Success");
                    setProductData((prevData: any) =>
                        prevData.map((p: any) =>
                            p.productId === item.productId
                                ? { ...p, isVisibleInMobile: isVisible }
                                : p
                        )
                    );
                } else {
                    toasts(response.data.message || "Failed to update visibility", "Error");
                }
            },
            (error) => {
                setLoadingProductId(null);
                toasts(error, "Error");
            }
        );
    };

    const handleSelectAllMobileVisibility = (isChecked: boolean) => {
        setLoadingProductId(0);
        const isVisible = isChecked ? 1 : 0;
        const postData = {
            licenseKey: getLicenseKey.toString(),
            productId: 0,
            isVisible: isVisible,
            userAccountId: userAccountId.toString()
        };

        updateMobileVisibility(postData,
            (response) => {
                setLoadingProductId(null);
                if (response.data.success) {
                    setProductData((prevData: any) =>
                        prevData.map((p: any) => ({
                            ...p,
                            isVisibleInMobile: isVisible
                        }))
                    );
                } else {
                    toasts(response.data.message || "Failed to update visibility", "Error");
                }
            },
            (error) => {
                setLoadingProductId(null);
                toasts(error, "Error");
            }
        );
    };

    return (
        <PageWrapper title={`Master Product List`}>
            <Page>
                <Card stretch data-tour='list'>
                    <CardHeader borderSize={1}>
                        <CardLabel icon='List' iconColor='info' className="col-lg-7">
                            <CardTitle tag='div' className='h5'>Master Product List</CardTitle>
                        </CardLabel>

                        <CardActions>
                            <div className='d-flex align-items-center gap-2'>
                                <ButtonGroup className="d-print-none" color='primary'>
                                    <Icon className="mt-1" icon='Search' size='2x' color='primary' />
                                    <Input id='searchInput' type='search' placeholder='Search...' onChange={columnVisibileForm.handleChange} value={columnVisibileForm.values.searchInput} />
                                </ButtonGroup>
                                <Button color='primary' icon="Add" onClick={openAddModal}>
                                    Add New
                                </Button>
                            </div>
                        </CardActions>
                    </CardHeader>
                    <CardBody>
                        {!dataStatus ?
                            <TableLoader /> :
                            <div className="table-responsive">
                                <table className='table table-modern table-hover small'>
                                    <thead className='table-primary'>
                                        <tr>
                                            <th scope='col' onClick={() => requestSort('sno')} className='cursor-pointer py-3 border-bottom-0 bg-light rounded-start'>
                                                <span className='small text-uppercase fw-bold'>S.No</span>
                                                <Icon size='lg' className={getClassNamesFor('sno')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('lotNo')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Lot No & <br /> Count No</span>
                                                <Icon size='lg' className={getClassNamesFor('lotNo')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('blend')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>S.Color</span>
                                                <Icon size='lg' className={getClassNamesFor('blend')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('noOfCone')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>No of Cone</span>
                                                <Icon size='lg' className={getClassNamesFor('noOfCone')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('coneWeight')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Cone Wt</span>
                                                <Icon size='lg' className={getClassNamesFor('coneWeight')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('tareWeight')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Tare Wt</span>
                                                <Icon size='lg' className={getClassNamesFor('tareWeight')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('netWeight')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Bag Wt</span>
                                                <Icon size='lg' className={getClassNamesFor('netWeight')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('targetWeight')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Target Wt</span>
                                                <Icon size='lg' className={getClassNamesFor('targetWeight')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('upperWeightTolerance')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Tolerance</span>
                                                <Icon size='lg' className={getClassNamesFor('upperWeightTolerance')} icon='FilterList' />
                                            </th>
                                            <th scope='col' className='py-3 border-bottom-0 bg-light text-center'>
                                                <div className='d-flex flex-column align-items-center justify-content-center gap-1'>
                                                    <span className='small text-uppercase fw-bold cursor-pointer' onClick={() => requestSort('isVisibleInMobile')}>
                                                        Visible
                                                        <Icon size='lg' className={getClassNamesFor('isVisibleInMobile')} icon='FilterList' />
                                                    </span>
                                                    <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '24px' }} onClick={(e) => e.stopPropagation()}>
                                                        {loadingProductId === 0 ? (
                                                            <Spinner color='primary' isSmall />
                                                        ) : (
                                                            <Checks
                                                                className='border border-primary mt-1'
                                                                id='select-all-mobile'
                                                                type='checkbox'
                                                                checked={filteredData.length > 0 && filteredData.every((item: any) => !!item.isVisibleInMobile)}
                                                                onChange={(e: any) => handleSelectAllMobileVisibility(e.target.checked)}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </th>
                                            <th scope='col' className='py-3 border-bottom-0 bg-light rounded-end'>
                                                <span className='small text-uppercase fw-bold text-center d-block'>Action</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    {productData.length > 0 ? (
                                        <>
                                            {filteredData.length > 0 ? <>
                                                {filteredData.map((item: any) => (
                                                    <tbody key={item.productId} className='border-top-0'>
                                                        <tr className='shadow-hover-sm transition-base'>
                                                            <td className='py-3 text-muted fw-semibold'>
                                                                <div className='d-flex align-items-center gap-2'>
                                                                    {item.sno}
                                                                    {(item.duplicateFlag === true || item.duplicateFlag === 1 || item.duplicateFlag === 'true') && (
                                                                        <Icon icon='Warning' color='danger' size='lg' title='Duplicate Product' />
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className='py-3'>
                                                                <div className='text-muted fw-semibold'>{item.lotNo}</div>
                                                                <div className='fw-semibold'>{item.countNo}</div>
                                                            </td>
                                                            <td className='py-3'>{item.blend}</td>
                                                            <td className='py-3'>{item.noOfCone ?? '-'}</td>
                                                            <td className='py-3'>{item.coneWeight ?? '-'}</td>
                                                            <td className='py-3'>{item.tareWeight}</td>
                                                            <td className='py-3'>{item.netWeight}</td>
                                                            <td className='py-3 fw-semibold'>{item.targetWeight}</td>
                                                            <td className='py-3'>
                                                                <div className='fw-semibold text-danger'>- {item.lowerWeightTolerance}</div>
                                                                <div className='fw-semibold text-success'>+ {item.upperWeightTolerance}</div>
                                                            </td>
                                                            <td className='py-3 text-center'>
                                                                <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '24px' }}>
                                                                    {loadingProductId === item.productId ? (
                                                                        <Spinner color='primary' isSmall />
                                                                    ) : (
                                                                        <Checks
                                                                            className='border border-primary'
                                                                            id={`isVisibleInMobile-${item.productId}`}
                                                                            type='checkbox'
                                                                            checked={!!item.isVisibleInMobile}
                                                                            onChange={(e: any) => handleMobileVisibilityChange(item, e.target.checked)}
                                                                        />
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className='text-center py-3'>
                                                                <Button
                                                                    icon='Edit'
                                                                    color='info'
                                                                    isLight
                                                                    size={'sm'}
                                                                    onClick={() => openEditModal(item)}
                                                                    className='me-2'
                                                                />
                                                                <Button
                                                                    icon='Delete'
                                                                    color='danger'
                                                                    size={'sm'}
                                                                    isLight
                                                                    onClick={() => onDelete(item.productId)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                ))}
                                            </> :
                                                <NoDataMsg columnsCount={12} msg={noDataMsg || 'No data found'} />
                                            }
                                        </>
                                    ) : (
                                        <NoDataMsg columnsCount={12} msg={noDataMsg || 'No data found'} />
                                    )}
                                </table>
                            </div>
                        }
                    </CardBody>
                    <PaginationButtons className="d-print-none" data={items} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
                </Card>
            </Page>

            <OffCanvas
                setOpen={setIsOffCanvasOpen}
                isOpen={isOffCanvasOpen}
                titleId='addMasterProduct'
                isBodyScroll
                isBackdrop
                isStaticBackdrop
            >
                <OffCanvasHeader onClick={() => setIsOffCanvasOpen(false)}>
                    <OffCanvasTitle id='addMasterProduct'>{isEditMode ? 'Edit Master Product' : 'Add Master Product'}</OffCanvasTitle>
                </OffCanvasHeader>
                <OffCanvasBody>
                    <div className='row g-4'>
                        {isEditMode ? (
                            <>
                                <div className='col-12'>
                                    <FormGroup id='lotNoEdit' label='Lot No'>
                                        <div className='d-flex align-items-center'>
                                            <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                                {isLotInput ? (
                                                    <Input
                                                        id='lotNo'
                                                        name='lotNo'
                                                        placeholder='Enter Lot No'
                                                        onChange={formik.handleChange}
                                                        value={formik.values.lotNo}
                                                        isValid={formik.touched.lotNo ? !formik.errors.lotNo : undefined}
                                                        isTouched={formik.touched.lotNo}
                                                        invalidFeedback={formik.errors.lotNo as string}
                                                        isValidMessage={false}
                                                        autoComplete='off'
                                                    />
                                                ) : (
                                                    <SearchableSelect
                                                        id='lotNoEdit'
                                                        ariaLabel='Lot No'
                                                        placeholder='Select Lot No'
                                                        value={lotSelected}
                                                        onChange={(val: any) => setLotSelected(val)}
                                                        onBlur={() => formik.setFieldTouched('lotNo', true)}
                                                        isValid={formik.touched.lotNo ? !formik.errors.lotNo : undefined}
                                                        isTouched={formik.touched.lotNo}
                                                        invalidFeedback={formik.errors.lotNo as string}
                                                        isValidMessage={false}
                                                        list={lotList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                        required
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                color='info'
                                                isLight
                                                icon={isLotInput ? 'List' : 'Add'}
                                                onClick={() => setIsLotInput(!isLotInput)}
                                                className='rounded-circle shadow-sm ms-2'
                                                style={{ width: '38px', height: '38px', padding: '0' }}
                                            />
                                        </div>
                                        {formik.touched.lotNo && formik.errors.lotNo ? (
                                            <div className='text-danger small mt-1'>{formik.errors.lotNo as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-12'>
                                    <FormGroup id='countNoEdit' label='Count No'>
                                        <div className='d-flex align-items-center'>
                                            <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                                {isCountInput ? (
                                                    <Input
                                                        id='countNo'
                                                        name='countNo'
                                                        placeholder='Enter Count No'
                                                        onChange={formik.handleChange}
                                                        value={formik.values.countNo}
                                                        isValid={formik.touched.countNo ? !formik.errors.countNo : undefined}
                                                        isTouched={formik.touched.countNo}
                                                        invalidFeedback={formik.errors.countNo as string}
                                                        isValidMessage={false}
                                                        autoComplete='off'
                                                    />
                                                ) : (
                                                    <SearchableSelect
                                                        id='countNoEdit'
                                                        ariaLabel='Count No'
                                                        placeholder='Select Count No'
                                                        value={countSelected}
                                                        onChange={(val: any) => setCountSelected(val)}
                                                        onBlur={() => formik.setFieldTouched('countNo', true)}
                                                        isValid={formik.touched.countNo ? !formik.errors.countNo : undefined}
                                                        isTouched={formik.touched.countNo}
                                                        invalidFeedback={formik.errors.countNo as string}
                                                        isValidMessage={false}
                                                        list={countList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                        required
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                color='info'
                                                isLight
                                                icon={isCountInput ? 'List' : 'Add'}
                                                onClick={() => setIsCountInput(!isCountInput)}
                                                className='rounded-circle shadow-sm ms-2'
                                                style={{ width: '38px', height: '38px', padding: '0' }}
                                            />
                                        </div>
                                        {formik.touched.countNo && formik.errors.countNo ? (
                                            <div className='text-danger small mt-1'>{formik.errors.countNo as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-12'>
                                    <FormGroup id='blendEdit' label='S.Color'>
                                        <div className='d-flex align-items-center'>
                                            <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                                {isBlendInput ? (
                                                    <Input
                                                        id='blend'
                                                        name='blend'
                                                        placeholder='Enter S.Color'
                                                        onChange={formik.handleChange}
                                                        value={formik.values.blend}
                                                        isValid={formik.touched.blend ? !formik.errors.blend : undefined}
                                                        isTouched={formik.touched.blend}
                                                        invalidFeedback={formik.errors.blend as string}
                                                        isValidMessage={false}
                                                        autoComplete='off'
                                                    />
                                                ) : (
                                                    <SearchableSelect
                                                        id='blendEdit'
                                                        ariaLabel='S.Color'
                                                        placeholder='Select S.Color'
                                                        value={blendSelected}
                                                        onChange={(val: any) => setBlendSelected(val)}
                                                        onBlur={() => formik.setFieldTouched('blend', true)}
                                                        isValid={formik.touched.blend ? !formik.errors.blend : undefined}
                                                        isTouched={formik.touched.blend}
                                                        invalidFeedback={formik.errors.blend as string}
                                                        isValidMessage={false}
                                                        list={blendList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                        required
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                color='info'
                                                isLight
                                                icon={isBlendInput ? 'List' : 'Add'}
                                                onClick={() => setIsBlendInput(!isBlendInput)}
                                                className='rounded-circle shadow-sm ms-2'
                                                style={{ width: '38px', height: '38px', padding: '0' }}
                                            />
                                        </div>
                                        {formik.touched.blend && formik.errors.blend ? (
                                            <div className='text-danger small mt-1'>{formik.errors.blend as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-6'>
                                    <FormGroup id='noOfConeEdit' label='No of Cone'>
                                        <Input
                                            id='noOfCone'
                                            name='noOfCone'
                                            type='number'
                                            placeholder='Enter No of Cone'
                                            onChange={formik.handleChange}
                                            value={formik.values.noOfCone}
                                            isValid={formik.touched.noOfCone ? !formik.errors.noOfCone : undefined}
                                            isTouched={formik.touched.noOfCone}
                                            invalidFeedback={formik.errors.noOfCone as string}
                                            isValidMessage={false}
                                            autoComplete='off'
                                        />
                                        {formik.touched.noOfCone && formik.errors.noOfCone ? (
                                            <div className='text-danger small mt-1'>{formik.errors.noOfCone as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-6'>
                                    <FormGroup id='coneWeightEdit' label='Cone Wt'>
                                        <Input
                                            id='coneWeight'
                                            name='coneWeight'
                                            type='number'
                                            placeholder='Enter Cone Wt'
                                            onChange={formik.handleChange}
                                            value={formik.values.coneWeight}
                                            isValid={formik.touched.coneWeight ? !formik.errors.coneWeight : undefined}
                                            isTouched={formik.touched.coneWeight}
                                            invalidFeedback={formik.errors.coneWeight as string}
                                            isValidMessage={false}
                                            autoComplete='off'
                                        />
                                        {formik.touched.coneWeight && formik.errors.coneWeight ? (
                                            <div className='text-danger small mt-1'>{formik.errors.coneWeight as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className='col-12'>
                                    <FormGroup id='lotNo' label='Lot No'>
                                        <div className='d-flex align-items-center'>
                                            <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                                {isLotInput ? (
                                                    <Input
                                                        id='lotNo'
                                                        name='lotNo'
                                                        placeholder='Enter Lot No'
                                                        onChange={formik.handleChange}
                                                        value={formik.values.lotNo}
                                                        isValid={formik.touched.lotNo ? !formik.errors.lotNo : undefined}
                                                        isTouched={formik.touched.lotNo}
                                                        invalidFeedback={formik.errors.lotNo as string}
                                                        isValidMessage={false}
                                                        autoComplete='off'
                                                    />
                                                ) : (
                                                    <SearchableSelect
                                                        id='lotNo'
                                                        ariaLabel='Lot No'
                                                        placeholder='Select Lot No'
                                                        value={lotSelected}
                                                        onChange={(val: any) => setLotSelected(val)}
                                                        onBlur={() => formik.setFieldTouched('lotNo', true)}
                                                        isValid={formik.touched.lotNo ? !formik.errors.lotNo : undefined}
                                                        isTouched={formik.touched.lotNo}
                                                        invalidFeedback={formik.errors.lotNo as string}
                                                        isValidMessage={false}
                                                        list={lotList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                        required
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                color='info'
                                                isLight
                                                icon={isLotInput ? 'List' : 'Add'}
                                                onClick={() => setIsLotInput(!isLotInput)}
                                                className='rounded-circle shadow-sm ms-2'
                                                style={{ width: '38px', height: '38px', padding: '0' }}
                                            />
                                        </div>
                                        {formik.touched.lotNo && formik.errors.lotNo ? (
                                            <div className='text-danger small mt-1'>{formik.errors.lotNo as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-12'>
                                    <FormGroup id='countNo' label='Count No'>
                                        <div className='d-flex align-items-center'>
                                            <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                                {isCountInput ? (
                                                    <Input
                                                        id='countNo'
                                                        name='countNo'
                                                        placeholder='Enter Count No'
                                                        onChange={formik.handleChange}
                                                        value={formik.values.countNo}
                                                        isValid={formik.touched.countNo ? !formik.errors.countNo : undefined}
                                                        isTouched={formik.touched.countNo}
                                                        invalidFeedback={formik.errors.countNo as string}
                                                        isValidMessage={false}
                                                        autoComplete='off'
                                                    />
                                                ) : (
                                                    <SearchableSelect
                                                        id='countNo'
                                                        ariaLabel='Count No'
                                                        placeholder='Select Count No'
                                                        value={countSelected}
                                                        onChange={(val: any) => setCountSelected(val)}
                                                        onBlur={() => formik.setFieldTouched('countNo', true)}
                                                        isValid={formik.touched.countNo ? !formik.errors.countNo : undefined}
                                                        isTouched={formik.touched.countNo}
                                                        invalidFeedback={formik.errors.countNo as string}
                                                        isValidMessage={false}
                                                        list={countList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                        required
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                color='info'
                                                isLight
                                                icon={isCountInput ? 'List' : 'Add'}
                                                onClick={() => setIsCountInput(!isCountInput)}
                                                className='rounded-circle shadow-sm ms-2'
                                                style={{ width: '38px', height: '38px', padding: '0' }}
                                            />
                                        </div>
                                        {formik.touched.countNo && formik.errors.countNo ? (
                                            <div className='text-danger small mt-1'>{formik.errors.countNo as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-12'>
                                    <FormGroup id='blend' label='S.Color'>
                                        <div className='d-flex align-items-center'>
                                            <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                                {isBlendInput ? (
                                                    <Input
                                                        id='blend'
                                                        name='blend'
                                                        placeholder='Enter S.Color'
                                                        onChange={formik.handleChange}
                                                        value={formik.values.blend}
                                                        isValid={formik.touched.blend ? !formik.errors.blend : undefined}
                                                        isTouched={formik.touched.blend}
                                                        invalidFeedback={formik.errors.blend as string}
                                                        isValidMessage={false}
                                                        autoComplete='off'
                                                    />
                                                ) : (
                                                    <SearchableSelect
                                                        id='blend'
                                                        ariaLabel='S.Color'
                                                        placeholder='Select S.Color'
                                                        value={blendSelected}
                                                        onChange={(val: any) => setBlendSelected(val)}
                                                        onBlur={() => formik.setFieldTouched('blend', true)}
                                                        isValid={formik.touched.blend ? !formik.errors.blend : undefined}
                                                        isTouched={formik.touched.blend}
                                                        invalidFeedback={formik.errors.blend as string}
                                                        isValidMessage={false}
                                                        list={blendList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                        required
                                                    />
                                                )}
                                            </div>
                                            <Button
                                                color='info'
                                                isLight
                                                icon={isBlendInput ? 'List' : 'Add'}
                                                onClick={() => setIsBlendInput(!isBlendInput)}
                                                className='rounded-circle shadow-sm ms-2'
                                                style={{ width: '38px', height: '38px', padding: '0' }}
                                            />
                                        </div>
                                        {formik.touched.blend && formik.errors.blend ? (
                                            <div className='text-danger small mt-1'>{formik.errors.blend as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-6'>
                                    <FormGroup id='noOfCone' label='No of Cone'>
                                        <Input
                                            id='noOfCone'
                                            name='noOfCone'
                                            type='number'
                                            placeholder='Enter No of Cone'
                                            onChange={formik.handleChange}
                                            value={formik.values.noOfCone}
                                            isValid={formik.touched.noOfCone ? !formik.errors.noOfCone : undefined}
                                            isTouched={formik.touched.noOfCone}
                                            invalidFeedback={formik.errors.noOfCone as string}
                                            isValidMessage={false}
                                            autoComplete='off'
                                        />
                                        {formik.touched.noOfCone && formik.errors.noOfCone ? (
                                            <div className='text-danger small mt-1'>{formik.errors.noOfCone as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>

                                <div className='col-6'>
                                    <FormGroup id='coneWeight' label='Cone Wt'>
                                        <Input
                                            id='coneWeight'
                                            name='coneWeight'
                                            type='number'
                                            placeholder='Enter Cone Wt'
                                            onChange={formik.handleChange}
                                            value={formik.values.coneWeight}
                                            isValid={formik.touched.coneWeight ? !formik.errors.coneWeight : undefined}
                                            isTouched={formik.touched.coneWeight}
                                            invalidFeedback={formik.errors.coneWeight as string}
                                            isValidMessage={false}
                                            autoComplete='off'
                                        />
                                        {formik.touched.coneWeight && formik.errors.coneWeight ? (
                                            <div className='text-danger small mt-1'>{formik.errors.coneWeight as string}</div>
                                        ) : <></>}
                                    </FormGroup>
                                </div>
                            </>
                        )}

                        <div className='col-12'>
                            <FormGroup id='tareWeight' label='Tare Wt'>
                                <div className='d-flex align-items-center'>
                                    <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                        {isTareInput ? (
                                            <Input
                                                id='tareWeight'
                                                name='tareWeight'
                                                type='number'
                                                placeholder='Enter Tare Wt'
                                                onChange={formik.handleChange}
                                                value={formik.values.tareWeight}
                                                isValid={formik.touched.tareWeight ? !formik.errors.tareWeight : undefined}
                                                isTouched={formik.touched.tareWeight}
                                                invalidFeedback={formik.errors.tareWeight as string}
                                                isValidMessage={false}
                                            />
                                        ) : (
                                            <SearchableSelect
                                                id='tareWeight'
                                                ariaLabel='Tare Wt'
                                                placeholder='Select Tare Wt'
                                                value={tareSelected}
                                                onChange={(val: any) => setTareSelected(val)}
                                                onBlur={() => formik.setFieldTouched('tareWeight', true)}
                                                isValid={formik.touched.tareWeight ? !formik.errors.tareWeight : undefined}
                                                isTouched={formik.touched.tareWeight}
                                                invalidFeedback={formik.errors.tareWeight as string}
                                                isValidMessage={false}
                                                list={tareList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                required
                                            />
                                        )}
                                    </div>
                                    <Button
                                        color='info'
                                        isLight
                                        icon={isTareInput ? 'List' : 'Add'}
                                        onClick={() => setIsTareInput(!isTareInput)}
                                        className='rounded-circle shadow-sm ms-2'
                                        style={{ width: '38px', height: '38px', padding: '0' }}
                                    />
                                </div>
                                {formik.touched.tareWeight && formik.errors.tareWeight ? (
                                    <div className='text-danger small mt-1'>{formik.errors.tareWeight as string}</div>
                                ) : <></>}
                            </FormGroup>
                        </div>

                        <div className='col-12'>
                            <FormGroup id='netWeight' label='Bag Wt'>
                                <div className='d-flex align-items-center'>
                                    <div className="flex-grow-1" onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
                                        {isNetInput ? (
                                            <Input
                                                id='netWeight'
                                                name='netWeight'
                                                type='number'
                                                placeholder='Enter Bag Wt'
                                                onChange={formik.handleChange}
                                                value={formik.values.netWeight}
                                                isValid={formik.touched.netWeight ? !formik.errors.netWeight : undefined}
                                                isTouched={formik.touched.netWeight}
                                                invalidFeedback={formik.errors.netWeight as string}
                                                isValidMessage={false}
                                            />
                                        ) : (
                                            <SearchableSelect
                                                id='netWeight'
                                                ariaLabel='Bag Wt'
                                                placeholder='Select Bag Wt'
                                                value={netSelected}
                                                onChange={(val: any) => setNetSelected(val)}
                                                onBlur={() => formik.setFieldTouched('netWeight', true)}
                                                isValid={formik.touched.netWeight ? !formik.errors.netWeight : undefined}
                                                isTouched={formik.touched.netWeight}
                                                invalidFeedback={formik.errors.netWeight as string}
                                                isValidMessage={false}
                                                list={netList.map((i: any) => ({ value: i.subModuleTypeId, label: i.subModuleType }))}
                                                required
                                            />
                                        )}
                                    </div>
                                    <Button
                                        color='info'
                                        isLight
                                        icon={isNetInput ? 'List' : 'Add'}
                                        onClick={() => setIsNetInput(!isNetInput)}
                                        className='rounded-circle shadow-sm ms-2'
                                        style={{ width: '38px', height: '38px', padding: '0' }}
                                    />
                                </div>
                                {formik.touched.netWeight && formik.errors.netWeight ? (
                                    <div className='text-danger small mt-1'>{formik.errors.netWeight as string}</div>
                                ) : <></>}
                            </FormGroup>
                        </div>

                        <div className='col-12'>
                            <FormGroup id='targetWeight' label='Target Wt'>
                                <Input
                                    id='targetWeight'
                                    name='targetWeight'
                                    disabled
                                    value={formik.values.targetWeight}
                                />
                            </FormGroup>
                        </div>

                        <div className='col-6'>
                            <FormGroup id='lowerlWeightToerance' label='Tolerance (-)'>
                                <Input
                                    id='lowerWeightTolerance'
                                    name='lowerWeightTolerance'
                                    type='number'
                                    placeholder='Enter Tolerance'
                                    onChange={formik.handleChange}
                                    value={formik.values.lowerWeightTolerance}
                                    isValid={formik.touched.lowerWeightTolerance ? !formik.errors.lowerWeightTolerance : undefined}
                                    isTouched={formik.touched.lowerWeightTolerance}
                                    invalidFeedback={formik.errors.lowerWeightTolerance as string}
                                    isValidMessage={false}
                                />
                                {formik.touched.lowerWeightTolerance && formik.errors.lowerWeightTolerance ? (
                                    <div className='text-danger small mt-1'>{formik.errors.lowerWeightTolerance as string}</div>
                                ) : <></>}
                            </FormGroup>
                        </div>

                        <div className='col-6'>
                            <FormGroup id='upperWeightTolerance' label='Tolerance (+)'>
                                <Input
                                    id='upperWeightTolerance'
                                    name='upperWeightTolerance'
                                    type='number'
                                    placeholder='Enter Tolerance'
                                    onChange={formik.handleChange}
                                    value={formik.values.upperWeightTolerance}
                                    isValid={formik.touched.upperWeightTolerance ? !formik.errors.upperWeightTolerance : undefined}
                                    isTouched={formik.touched.upperWeightTolerance}
                                    invalidFeedback={formik.errors.upperWeightTolerance as string}
                                    isValidMessage={false}
                                />
                                {formik.touched.upperWeightTolerance && formik.errors.upperWeightTolerance ? (
                                    <div className='text-danger small mt-1'>{formik.errors.upperWeightTolerance as string}</div>
                                ) : <></>}
                            </FormGroup>
                        </div>
                    </div>
                </OffCanvasBody>
                <div className='row m-0'>
                    <div className='col-12 p-3'>
                        <Button color='info' icon='Save' className='w-100' onClick={() => formik.handleSubmit()}>
                            Save
                        </Button>
                    </div>
                </div>
            </OffCanvas>

            {/* ── Delete Confirmation Modal ── */}
            <Modal
                id='deleteConfirmModal'
                isOpen={isDeleteModalOpen}
                setIsOpen={setIsDeleteModalOpen}
                size='sm'
            >
                <ModalHeader setIsOpen={setIsDeleteModalOpen}>
                    <></>
                </ModalHeader>
                <ModalBody>
                    <div className='text-center'>
                        <Icon icon='ReportProblem' size='3x' color='danger' className='mb-3' />
                        <h5 className='fw-bold'>Are you sure you want to delete?</h5>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color='info' isLight onClick={() => setIsDeleteModalOpen(false)} size={'sm'}>
                        Cancel
                    </Button>
                    <Button color='danger' onClick={confirmDelete} size={'sm'}>
                        Yes, Delete
                    </Button>
                </ModalFooter>
            </Modal>

            <AlertService setIsOpen={setIsAlertOpen} isOpen={isAlertOpen} alertStatus={alertStatus} />
        </PageWrapper>
    )
}

export default MasterProduct